import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Backdrop } from "@mui/material";
import { Card } from "reactstrap";

import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import ALoader from "views/pages/manage/common/a-loader";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { fetchStateAndYearDropdowns, searchPaymentSlab } from "../helper";

const PaymentSlabs = () => {
  const history = useHistory();
  // Fetch BU options from Redux masterDropdowns
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns,
  );
  const buOptions = (masterDropdowns?.businessArea || []).map((item) => ({
    label: item.label,
    value: item.businessAreaId,
  }));
  const [dropdownOptions, setDropdownOptions] = useState({
    stateOptions: [],
    yearOptions: [],
  });
  const [form, setForm] = useState({
    state: [],
    bu: [],
    year: [],
  });
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  // const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    populateDropdowns();
  }, []);

  const populateDropdowns = async () => {
    const response = await fetchStateAndYearDropdowns();
    setDropdownOptions(response);
  };

  const handleForm = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  // Validation: at least one field must be filled
  const isFormValid =
    (form.state && form.state.length > 0) ||
    (form.bu && form.bu.length > 0) ||
    (form.year && form.year.length > 0);

  const handleSearch = async (page = currentPage, size = 50) => {
    setLoading(true);

    const payload = {
      stateIds: form.state?.map((item) => item.value) || [],
      businessUnitIds: form.bu?.map((item) => item.value) || [],
      yearIds: form.year?.map((item) => item.value) || [],
    };
    try {
      // Fetch payment slabs from API with pagination
      const result = await searchPaymentSlab(payload, page, size);
      setCurrentPage(result?.data.currentPage);
      setResults(result?.data?.data || []);
      setTotalCount(result?.data?.totalRecords || 0);

      if (result?.code === 200 && result?.data?.data.length === 0)
        failureToast("No records found!");
    } catch (e) {
      setResults([]);
      setTotalCount(0);
      setCurrentPage(0);
    } finally {
      setLoading(false);
    }
  };

  const nextButtonHandler = (newPage) => {
    handleSearch(newPage);
  };

  const columns = [
    new AGridColDef("state", "State")
      .setWidth(120)
      .renderCellComponent((params) => params.value || "-"),
    new AGridColDef("businessUnit", "BU")
      .setWidth(80)
      .renderCellComponent((params) => params.value || "-"),
    new AGridColDef("year", "Year")
      .setWidth(80)
      .renderCellComponent((params) => params.value || "-"),
    new AGridColDef("action", "Actions", false)
      .setMinWidth(100)
      .pinColumnLast(true)
      .renderCellComponent((params) => (
        <AButton
          variant="primary_filled"
          size="xs"
          onClick={() => {
            history.push(`/admin/paymentSlab/${params.row.id}`);
          }}
        >
          View
        </AButton>
      )),
  ];

  return (
    <div className="d-flex flex-column p-4" style={{ width: "100%" }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <IconButtonWrapper onClick={() => window.history.back()}>
            <BackIcon />
          </IconButtonWrapper>
          <h2 className="color-black-60 text-bold mb-0 ml-2">
            Admission advisor payment slab
          </h2>
        </div>
        <AButton
          variant="primary_filled"
          onClick={() => history.push("/admin/paymentSlab/new")}
        >
          Add a new slab
        </AButton>
      </div>

      <Card className="p-4">
        <h2 className="mb-2 text-bold">Search a slab</h2>
        <div
          style={{
            width: "70%",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr) auto", // Three columns for dropdowns, auto for button
            gap: "15px",
          }}
        >
          <AAutoComplete
            label="State"
            placeholder="Select"
            isMulti={true}
            isShowCount
            items={dropdownOptions.stateOptions}
            currentValue={form.state}
            handleChange={(value) => handleForm("state", value)}
            height="45px"
          />

          <AAutoComplete
            label="Business Unit"
            placeholder="Select"
            isMulti={true}
            isShowCount
            items={buOptions}
            currentValue={form.bu}
            handleChange={(value) => handleForm("bu", value)}
            height="45px"
          />

          <AAutoComplete
            label="Year"
            placeholder="Select"
            isMulti={true}
            isShowCount
            items={dropdownOptions.yearOptions}
            currentValue={form.year}
            handleChange={(value) => handleForm("year", value)}
            height="45px"
          />

          <AButton
            variant="primary_filled"
            disabled={!isFormValid || loading}
            onClick={() => {
              setCurrentPage(0);
              handleSearch(0, 50);
            }}
            className="mt-auto"
          >
            {loading ? "Searching..." : "Search slab"}
          </AButton>
        </div>
      </Card>

      {loading && (
        <Backdrop
          open={loading}
          sx={(theme) => ({
            color: "#fff",
            zIndex: 2300,
          })}
        >
          <ALoader className="m-auto" />
        </Backdrop>
      )}

      {/* Table Results */}

      <Card className="px-4" style={{ height: "100%" }}>
        <ADataGrid
          rows={results}
          columns={columns}
          rowId={(row, idx) => row.id || idx}
          loading={loading}
          // pageSize={50}
          currentPage={currentPage}
          nextButtonHandler={nextButtonHandler}
          rowCount={totalCount}
        />
      </Card>
    </div>
  );
};

export default PaymentSlabs;
